import React from "react";
import { Form } from 'react-bootstrap'

const RenderTextarea = (props) => {
    return (<Form.Group data-testid="RadioTextAreaCmp"><Form.Control as="textarea" rows={3} {...props} /></Form.Group>)
};
export default RenderTextarea;